import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { Supervisor } from '../../supervisor';
import { FsService } from '../../fs.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { RemoveFsConfirmComponent } from './remove-fs-confirm/remove-fs-confirm.component';
import { EditFsComponent } from './edit-fs/edit-fs.component';
import { TransactionService } from '../../transaction.service';
import { runInThisContext } from 'vm';
import { Shift } from '../../shift';
import { ShiftsComponent } from '../shifts.component';

@Component({
  selector: 'app-fs-item',
  templateUrl: './fs-item.component.html',
  styleUrls: ['./fs-item.component.scss']
})
export class FsItemComponent implements OnInit {

  itemId = '';
  @Input() site: any;
  @Input() siteId: any;
  @Input() supervisor: Supervisor;
  @Input() shifts: Shift[];
  @Input() otherFS: Supervisor[];
  @Input() index: number;
  @Output() updated = new EventEmitter<boolean>();
  clearance = localStorage.getItem('clearance');
  startH: any;
  startM: any;
  endH: any;
  endM: any;
  otherSupervisors: any = '';
  inspectors: any = '';

  constructor(
    private fsService: FsService,
    public dialog: MatDialog,
    private transactionService: TransactionService,
    private shiftsComponent: ShiftsComponent
  ) { }

  ngOnInit() {
    this.itemId = this.supervisor.itemId;

    for (const fs of this.otherFS) {
      if (fs.shift === this.supervisor.shift) {
        this.otherSupervisors += fs.name + ' ( ' + fs.phone + ' )' + '; ';
      }
    }
    // REMOVE TRAILING , //
    if (this.otherSupervisors !== '') {
      this.otherSupervisors = this.otherSupervisors.slice(0, -2);
    }

    for (const s of this.shifts) {
      if (s.name === this.supervisor.shift) {
        for (const p of s.positions) {
          if (p.status === 1) {
            this.inspectors += p.name + '; ';
          }
        }
      }
    }
    // REMOVE TRAILING , //
    if (this.inspectors !== '') {
      this.inspectors = this.inspectors.slice(0, -2);
    }

    if (this.supervisor.shift === this.supervisor.c1label) {
      this.startH = this.supervisor.amStartH;
      this.startM = this.supervisor.amStartM;
      this.endH   = this.supervisor.amEndH;
      this.endM   = this.supervisor.amEndM;
    } else if (this.supervisor.shift === this.supervisor.c2label) {
      this.startH = this.supervisor.pmStartH;
      this.startM = this.supervisor.pmStartM;
      this.endH   = this.supervisor.pmEndH;
      this.endM   = this.supervisor.pmEndM;
    } else if (this.supervisor.shift === this.supervisor.c3label) {
      this.startH = this.supervisor.mnStartH;
      this.startM = this.supervisor.mnStartM;
      this.endH   = this.supervisor.mnEndH;
      this.endM   = this.supervisor.mnEndM;
    } else if (this.supervisor.shift === this.supervisor.c4label) {
      this.startH = this.supervisor.c4StartH;
      this.startM = this.supervisor.c4StartM;
      this.endH   = this.supervisor.c4EndH;
      this.endM   = this.supervisor.c4EndM;
    } else if (this.supervisor.shift === this.supervisor.c2label) {
      this.startH = this.supervisor.c5StartH;
      this.startM = this.supervisor.c5StartM;
      this.endH   = this.supervisor.c5EndH;
      this.endM   = this.supervisor.c5EndM;
    } else if (this.supervisor.shift === this.supervisor.c2label) {
      this.startH = this.supervisor.c6StartH;
      this.startM = this.supervisor.c6StartM;
      this.endH   = this.supervisor.c6EndH;
      this.endM   = this.supervisor.c6EndM;
    }
    if (this.startH < 10) {
      this.startH = '0' + this.startH;
    }
    if (this.startM === 0) {
      this.startM = this.startM + '0';
    }
    if (this.endH < 10) {
      this.endH = '0' + this.endH;
    }
    if (this.endM === 0) {
      this.endM = this.endM + '0';
    }
  }

  removeFsClicked(supervisor: Supervisor) {
    this.dialog
      .open(RemoveFsConfirmComponent, {width: '200', autoFocus: true, data: {name: supervisor.name}})
      .afterClosed()
      .subscribe(result => {
        if (result.status === 'confirmed') {
          this.removeFs(supervisor);
        }
      }
    );
  }

  removeFs(supervisor: Supervisor) {
    this.fsService.removeByItemId(supervisor.itemId)
      .subscribe((data) => {
        // this.updated.emit(true);
        this.otherFS.splice(this.index, 1); // remove supervisor at the specified index
        this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, supervisor.shift,
        'Shift Leader ' + supervisor.name + ' removed from the ' + supervisor.shift + ' shift at ' + this.site)
          .subscribe((tdata) => {
          }
        );
      });
  }

  editFsClicked(item: any) {
    if (localStorage.getItem('clearance') > '2') {
      this.dialog.open(EditFsComponent, {width: '80%', autoFocus: true, data: {itemId: this.itemId, site: this.site, siteId: this.siteId,
        clickedItem: item}})
      .afterClosed()
      .subscribe(result => {
        if (result.result !== 'cancelled') {
          // this.updated.emit(true);
          this.supervisor = {
            ...result.supervisor,
            agencyRequirements: this.supervisor.agencyRequirements
          };
        }
      });
    }
  }

  emailFsClicked(item: any) {
    const shiftStr = this.supervisor.shift + ' (' + this.startH + ':' + this.startM + '-' + this.endH + ':' + this.endM + ')';
    this.fsService.emailSupervisor(this.site, shiftStr, this.otherSupervisors, this.inspectors,
    this.supervisor.agencyRequirements, this.supervisor.email, this.formatDate(),
    this.supervisor.siteAddress)
      .subscribe((data) => {
        alert('Email has been sent.');
      });
  }

  formatDate() {
    const yr: any = this.shiftsComponent.currDate.getFullYear();
    let mnth: any = this.shiftsComponent.currDate.getMonth() + 1;
    let day: any = this.shiftsComponent.currDate.getDate();

    if (mnth < 10) { mnth = '0' + mnth; }
    if (day < 10) { day = '0' + day; }

    return yr + '-' + mnth + '-' + day;
  }

  toggleFSWork(day: any, supervisor: Supervisor, field: string) {
    // field would be isSun, isSat, etc...
    // supervisor[field] would be supervisor.isSun for example
    this.fsService.toggleFSWork(this.itemId, day)
      .subscribe((data) => {
        supervisor[field] = supervisor[field] === 1 ? 0 : 1; // toggling date
        // this.updated.emit(true);
      });
  }

}
